"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var AccordionStore_1 = __importDefault(require("../helpers/AccordionStore"));
var Context = (0, react_1.createContext)(null);
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = new AccordionStore_1.default({
            expanded: _this.props.preExpanded,
            allowMultipleExpanded: _this.props.allowMultipleExpanded,
            allowZeroExpanded: _this.props.allowZeroExpanded,
        });
        _this.toggleExpanded = function (key) {
            _this.setState(function (state) { return state.toggleExpanded(key); }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(_this.state.expanded);
                }
            });
        };
        _this.isItemDisabled = function (key) {
            return _this.state.isItemDisabled(key);
        };
        _this.isItemExpanded = function (key) {
            return _this.state.isItemExpanded(key);
        };
        _this.getPanelAttributes = function (key, dangerouslySetExpanded) {
            return _this.state.getPanelAttributes(key, dangerouslySetExpanded);
        };
        _this.getHeadingAttributes = function () {
            // uuid: UUID
            return _this.state.getHeadingAttributes();
        };
        _this.getButtonAttributes = function (key, dangerouslySetExpanded) {
            return _this.state.getButtonAttributes(key, dangerouslySetExpanded);
        };
        return _this;
    }
    Provider.prototype.render = function () {
        var _a = this.state, allowZeroExpanded = _a.allowZeroExpanded, allowMultipleExpanded = _a.allowMultipleExpanded;
        var variant = this.props.variant;
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                allowMultipleExpanded: allowMultipleExpanded,
                allowZeroExpanded: allowZeroExpanded,
                toggleExpanded: this.toggleExpanded,
                isItemDisabled: this.isItemDisabled,
                isItemExpanded: this.isItemExpanded,
                getPanelAttributes: this.getPanelAttributes,
                getHeadingAttributes: this.getHeadingAttributes,
                getButtonAttributes: this.getButtonAttributes,
                variant: variant,
            } }, { children: this.props.children || null })));
    };
    Provider.defaultProps = {
        allowMultipleExpanded: false,
        allowZeroExpanded: false,
        variant: 'primary'
    };
    return Provider;
}(react_1.PureComponent));
exports.Provider = Provider;
var Consumer = /** @class */ (function (_super) {
    __extends(Consumer, _super);
    function Consumer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChildren = function (container) {
            return container ? _this.props.children(container) : null;
        };
        return _this;
    }
    Consumer.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: this.renderChildren });
    };
    return Consumer;
}(react_1.PureComponent));
exports.Consumer = Consumer;
//# sourceMappingURL=AccordionContext.js.map